import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "@/lib/api";
import Divider from "@/components/Divider";

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const storyImg = (slug) => `${API_BASE}/api/images/brand/pantry-${slug}`;

export default function Pantry() {
  const [pantry, setPantry] = useState([]);
  const [stories, setStories] = useState([]);
  useEffect(() => {
    let cancelled = false;
    client.get("/content/pantry").then(({ data }) => {
      if (cancelled) return;
      setPantry(data.pantry);
      setStories(data.stories);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return (
    <div className="bg-mizizi-cream">
      <header className="max-w-4xl mx-auto px-6 md:px-10 pt-24 md:pt-40 pb-16 text-center">
        <div className="overline text-mizizi-terracotta">The Pantry</div>
        <h1 className="font-serif font-light text-5xl md:text-7xl mt-6 leading-none">Ingredient Stories.</h1>
        <p className="mt-8 text-lg text-mizizi-charcoal/70">Where each ingredient comes from — and why it deserves its place on the shelf.</p>
      </header>

      <section className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-10">
        {stories.map((s, i) => (
          <article key={s.slug} data-testid={`ingredient-${s.slug}`} className="group">
            <div className="overflow-hidden aspect-[4/3]">
              <img src={storyImg(s.slug)} alt={s.title} className="recipe-cover w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="mt-6">
              <div className="overline text-mizizi-gold">{String(i + 1).padStart(2, "0")} · Ingredient</div>
              <h2 className="font-serif text-4xl mt-2 text-mizizi-charcoal">{s.title}</h2>
              <p className="mt-2 italic text-mizizi-charcoal/70">{s.hero}</p>
              <p className="mt-4 text-mizizi-charcoal/80 leading-relaxed">{s.body}</p>
            </div>
          </article>
        ))}
      </section>

      <Divider />

      <section className="bg-mizizi-charcoal text-mizizi-cream py-24">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <div className="overline text-mizizi-gold text-center">Stock Your Shelves</div>
          <h2 className="font-serif text-4xl md:text-5xl text-center mt-4">The Mizizi Pantry</h2>
          <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-10">
            {pantry.map((sec, i) => (
              <div key={sec.section} data-testid={`pantry-section-${i}`}>
                <div className="overline text-mizizi-gold hairline-b pb-3">{sec.section}</div>
                <ul className="mt-4 space-y-2 font-serif text-lg">
                  {sec.items.map((it) => <li key={it}>{it}</li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="text-center py-20">
        <Link to="/shop" data-testid="pantry-cta" className="pill pill-primary">Read the Full Pantry Guide</Link>
      </div>
    </div>
  );
}
